/*
首屏背景图视觉差效果, 只需要给首屏加即可
 */

export default {
  install(Vue) {
    Vue.directive("parallaxBackground", {
      inserted: (el) => {
        let $bg = $(el).find(".v-background").get(0);
        let els = $(el).find(".v-background>div,.v-fade-out-in").toArray();
        let title = $(el).find(".title-content").get(0);

        el.__backgroundTimer = requestAnimationFrame(function fn() {
          let { height, top } = $bg.getBoundingClientRect();
          let absTop = Math.abs(top);
          if (top <= 0 && absTop <= height * 2) {
            let scrollTop = absTop * 0.4;
            if (el.__scrollTop !== scrollTop) {
              //  标题动画
              if (title) {
                let titleOpacity = 1 - (absTop / height) * 2;
                title.style.opacity = titleOpacity;
                title.style.cssText = `opacity:${titleOpacity};transform:translateY(${
                  (1 - titleOpacity) * 0.2 * 100
                }%);`;
              }

              els.map((el) => {
                let $el = $(el);
                if ($el.hasClass("parallax-bg")) {
                  $(el)
                    .find(".parallax-wrap")
                    .map((key, _el) => {
                      $(_el).css(
                        "transform",
                        `translateY(${scrollTop * ((key + 1) * 0.2)}px)`
                      );
                    });
                } else {
                  $el.css("transform", `translateY(${scrollTop}px)`);
                }
              });

              el.__scrollTop = scrollTop;
            }
          }

          el.__backgroundTimer = requestAnimationFrame(fn);
        });
      },
      unbind(el) {
        cancelAnimationFrame(el.__backgroundTimer);
      },
    });
  },
};
